import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { get } from 'scriptjs';
import { take } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { AppStateService } from './services/app-state.service';
import { SessionService } from './services/session.service';
import { SDKErrorResponse } from "./models/sdk-error-response.model";
import { SDKResponse } from './models/sdk-response.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  origin: string;
  responseResult: SDKResponse | SDKErrorResponse | null;

  authenticated: boolean;
  invalidAccessToken: boolean;
  urlsToVisibleBanner = ['invoice-options', 'simulation'];

  SDK;

  constructor(
    private appState: AppStateService,
    private router: Router,
    private activated: ActivatedRoute,
    private session: SessionService,) {
    this.setAccessToken();
    this.isAuthenticated();
  }

  async ngOnInit(): Promise<void> {
    this.setLoading();

    let promise = await Promise.all([this.getOrigin(), this.getSDKResponse()]);
    this.origin = promise[0];
    this.responseResult = promise[1];

    // Adicionar listener de comunicação externa autorizada
    window.addEventListener('message', (e) => { /* console.log(event, 1); */ });

    // Adicionar listener para informar ao window pai que estou sendo fechado
    window.addEventListener('beforeunload', async (e) => {
      let promiseResponse = await Promise.all([this.getSDKResponse()]);
      this.responseResult = promiseResponse[0];
      let evento = {};

      if (this.responseResult) {
        evento = { close: true, success: this.responseResult.success, response: this.responseResult };
      } else {
        evento = { close: true, success: false, response: new SDKErrorResponse(true) };
      }
      window.opener.postMessage(evento, this.origin);
    });

    // Evento que escuta as mensagens vindas do pai
    window.onmessage = (event) => {
      if (event.origin === event.origin) {
        if (event.data.authResult) {
          let str = event.data.authResult.split('-xAc:');
          get(environment.sdk_url, () => {
            //@ts-ignore
            this.SDK = SemearDDC;
            this.authenticated = true;
            this.appState.setSaltResult(atob(str[0]));
            this.appState.setAuthResult(this.SDK.decrypt(str[1], atob(str[0])));
            this.router.navigate(['welcome']);
          });
        }
      } else {
        return;
      }
    };

    this.requestAuthResult();
  }

  setLoading() {
    this.appState.setLoading(true).then(success => {
      setTimeout(() => {
        this.appState.setLoading(false);
      }, 3000);
    });
  }

  loading(): boolean {
    let state = false;
    this.appState.getLoading.subscribe((_state) => state = _state);
    return state;
  }

  // setAuthResult(authResult: any) {
  //   console.log('auth result => ', authResult);
  //   sessionStorage.setItem(this.encrypt.decrypt(environment.localpoints.authResult), authResult.authResult);
  // }

  authenticate() {
    // if (this.activated.url) {
    //   this.authenticated = true;
    //   this.router.navigate(['invoice-options']);
    // }
  }

  async requestAuthResult() {
    try {
      this.pushMessage({ authResult: true });
    } catch (e) {
      // SILENCE
      // await this.appState.setLoading(false);
      this.invalidAccessToken = true;
      this.router.navigate(['']);
    }
  }

  pushMessage(message) {
    window.opener.postMessage(message, this.origin);
  }

  setAccessToken() {
    if (this.router.url === '/') {
      this.activated.queryParams.subscribe(queryParams => {
        if (queryParams.t) {
          this.appState.setAccessToken(queryParams.t);
        }
      });
    } else {
      this.appState.getAccessToken.pipe(take(1)).subscribe(accessToken => {
        this.authenticated = true;
      })
    }
  }

  getOrigin(): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        this.activated.queryParams.subscribe(queryParams => {
          if (queryParams.o) {
            this.appState.setOrigin(queryParams.o);
            resolve(queryParams.o);
          }
        })
      } catch (e) {
        reject(e);
      }
    })
  }

  getSDKResponse(): Promise<SDKResponse | SDKErrorResponse | null> {
    return new Promise((resolve, reject) => {
      try {
        this.appState.getSDKResponse.subscribe(result => {
          if (result) {
            resolve(result);
          } else {
            resolve(null);
          }
        });
      } catch (e) {
        reject(e);
      }
    })
  }

  async isAuthenticated() {
    this.authenticated = await this.session.isAuthenticated();
  }

  get bannerIsVisible() {
    const locationName = window.location.pathname.replace('/', '');
    if (this.urlsToVisibleBanner.find(a => a === locationName))
      return true;
    else
      return false;
  }

  get titleIsVisible() {
    const locationName = window.location.pathname.replace('/', '');
    if ('invoice-options' === locationName)
      return true;
    else
      return false;
  }
}
